import React from 'react';
import resources from '../../resources';
import { Row, Col } from 'antd';
import languages from '../../appdata/languages';
import StoreManager from '../../appdata';
import TextSection from '../BaseComponents/TextSection'
import TextSection2 from '../BaseComponents/TextSection2'
import TextSection3 from '../BaseComponents/TextSection3'

class Zalo2024Content extends React.Component {
  render() {
    
    const lg = StoreManager.appState.thisApp.state.currentLanguage;
    const lang = languages[lg].Zalo2024Content; // có thể dùng dynamic switch
    const {isMobile} = StoreManager.appState.thisApp.state

    return (
      <div style={{ lineHeight: 1.6 }}>
        <h2 style={{  fontFamily: 'Inter28-SemiBold', fontSize: isMobile ? 24 : 36, fontWeight: 600 }}>{lang.title}</h2>

        {/* Introduction */}
        <div style={{ marginTop: 24 }}>
          {lang.intro.map((p, idx) => <p key={idx}>{p}</p>)}
        </div>

        {/* Bar chart */}
        <div style={{ margin: '32px 0' }}>
          <img src={lg == 'vi' ? resources.images.Zalo2024Image1_vi :resources.images.Zalo2024Image1} alt="Zalo usage chart" style={{ width: '100%', maxWidth: 600 }} />
        </div>

        {/* Platform Highlights */}
        <TextSection title={lang.platformTitle} paragraphs={[lang.platformText]} />


        <TextSection title={lang.digitalplatformTitle} paragraphs={[lang.digitalplatformText1, lang.digitalplatformText2]} />
        {/* Icon cards */}
        <Row gutter={[24, 24]} style={{ marginTop: 24, marginBottom: 48 }}>
          {lang.stats.map((item, index) => (
            <Col xs={24} md={8} key={index}>
              <div style={{
                backgroundColor: '#EDF8FF',
                borderRadius: 16,
                padding: 16,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                height: 'calc(100% - 32px)',  // trừ đi padding

              }}>
                <img src={resources.icons[item.icon]} alt="icon" style={{ width: 50, height: 50, marginBottom: 12 }} />
                <div style={{ fontWeight: 600, color: '#F15A24', fontSize: 28, marginBottom: 4 }}>{item.value}</div>
                <div style={{ fontWeight: 600, fontFamily:'Inter28-SemiBold' , fontSize: 16, textAlign: 'left' }}>{item.text}</div>
              </div>
            </Col>
          ))}
        </Row>


        {/* AI Section */}
        <div style={{ marginTop: 40, marginBottom: 24 }}>
          <h4 style={{ fontSize: 24, fontWeight: 600 }}>{lang.aiTitle}</h4>
          {lang.aiText.map((p, i) => <p key={i}>{p}</p>)}

          <p style={{ fontWeight: 500, marginTop: 16 }}>{lang.aiHighlightsTitle}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>
          <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
            {lang.aiHighlights.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          </div>

          <p style={{ fontWeight: 500, marginTop: 16 }}>{lang.genAITitle}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>
          <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
            {lang.genAI.map((item, i) => <li key={i}>{item}</li>)}
          </ul>
          </div>
        </div>

        <div style={{ marginTop: 24 }}>
          <img src={lg == 'vi' ? resources.images.Zalo2024Image2_vi : resources.images.Zalo2024Image2} alt="Emergency Response Pie Chart" style={{ width: '100%', borderRadius: 16 }} />
        </div>

        <p>{lang.vmluText}</p>

        {/* Social Impact */}
        <div style={{ marginTop: 48, marginBottom: 48 }}>
          <h4 style={{ fontSize: 16, fontWeight: 600 }}>{lang.socialTitle}</h4>
          <p>{lang.socialIntro}</p>
          <div style={{ backgroundColor: '#EDF8FF', borderRadius: 16, padding: 24 }}>
          <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
            {lang.socialList.map((item, i) => (
              <li key={i}>
                {item.text}
                {item.sub && (
                  <ul style={{ paddingLeft: 20, marginTop: 8 }}>
                    {item.sub.map((s, j) => <li key={j}>{s}</li>)}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          </div>

          <div style={{ marginTop: 24 }}>
            <img src={lg == 'vi' ? resources.images.Zalo2024Image3_vi :resources.images.Zalo2024Image3} alt="Zalo OA Emergency Chart" style={{ width: '100%', borderRadius: 16 }} />
          </div>

          <p style={{ marginTop: 24 }}>{lang.typhoonText}</p>
          {/* <ul style={{ paddingLeft: 20, lineHeight: 1.8 }}>
            {lang.typhoonStats.map((item, i) => <li key={i}>{item}</li>)}
          </ul> */}

          <p style={{ marginTop: 24 }}>{lang.closing}</p>
        </div>
      </div>
    );
  }
}

export default Zalo2024Content;
